module.exports = __webpack_public_path__ + "img/구글로고.b627d8dd.png";